import React, { FC, memo } from 'react'
import { Facet } from '@ucheba/ui/components/Facet/desktop'
import { EEventsFacets } from '@ucheba/store/events/search/types'
import { searchQueryByEventsFacet, titleByEventsFacetName } from '../constants'
import { useEventsSearchPageFacetsCore } from '../bll'

const EventsPageFacets: FC = () => {
  const { facets, onSubmit } = useEventsSearchPageFacetsCore()

  if (!facets) return null

  return (
    <>
      <Facet
        onSubmit={onSubmit(EEventsFacets.formats)}
        title={titleByEventsFacetName[EEventsFacets.formats]}
        controlName={searchQueryByEventsFacet[EEventsFacets.formats]}
        items={facets[EEventsFacets.formats]}
      />

      <Facet
        onSubmit={onSubmit(EEventsFacets.locations)}
        title={titleByEventsFacetName[EEventsFacets.locations]}
        controlName={searchQueryByEventsFacet[EEventsFacets.locations]}
        items={facets[EEventsFacets.locations]}
        maxItems={4}
      />
    </>
  )
}

export default memo(EventsPageFacets)
